export const checkNullObjValues = (data: object): boolean => {
	if (!data) return false
	return Object.values(data).some((value) => value !== undefined && value !== null)
}
